export interface ResetLoginRequest {
  email: string;
}

export async function resetPassword(request: ResetLoginRequest) {
  const storeId = document.querySelector('meta[name="x-storeid"]')?.getAttribute('content');

  const response = await fetch('/umbraco/api/member/member/requestPasswordReset', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-storeid': storeId,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return true;
}
